import classNames from 'classnames'
import { Popup } from '../../components/popup'
import { useDeviceMedia } from '../../hooks/use-device-media'
import { BaseModal, BaseModalContent, BaseModalHeader } from '../modal'
import styles from './Dropdown.module.scss'
import { useDropdown } from './hooks'
import type { DropdownProps } from './types'

const Dropdown = ({
  className,
  closeOnClickOutside,
  children,
  id,
  isOpen,
  onClose,
  role,
  title,
  trigger,
}: DropdownProps) => {
  const { isDesktop } = useDeviceMedia() // TODO: review this approach https://glovoapp.atlassian.net/browse/PTXO-1542
  const { handleClose, onClickOutside } = useDropdown({ closeOnClickOutside, isOpen, onClose })
  return (
    <div className={classNames(styles['pintxo-dropdown'], className)}>
      {/* Show Popup on Desktop and modal on tablet and mobile */}
      {isDesktop ? (
        <Popup
          trigger={trigger}
          onClickOutside={onClickOutside}
          isOpen={isOpen}
          {...(role ? { role } : {})}
          {...(id ? { id } : {})}
        >
          {children}
        </Popup>
      ) : (
        <div className="pintxo-dropdown">
          {trigger}
          <BaseModal
            isOpen={!!isOpen}
            showCloseButton={closeOnClickOutside}
            overlayClose={!!closeOnClickOutside}
            onClose={handleClose}
            {...(role ? { role } : {})}
            {...(id ? { id } : {})}
          >
            <BaseModalHeader>{title}</BaseModalHeader>
            <BaseModalContent>{children}</BaseModalContent>
          </BaseModal>
        </div>
      )}
    </div>
  )
}

export default Dropdown
